import React from "react";
import { t } from "ttag";

import { IPaymentMethodFormProps } from "./PaymentMethod.interfaces";

type IProps = IPaymentMethodFormProps;

interface IState {}

// TODO(ssr, LEVEL 1 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 1/10 due to trivial render-only component with no state or logic.
export class PayLater extends React.Component<IProps, IState> {
    render() {
        return (
            <div className="form__error">
                <p>
                    <strong>
                        {t`Our payment processor is currently experiencing technical issues. You may submit your order now and our team will contact you to confirm payment as soon as our credit card payment system is operational.`}
                    </strong>
                    <br />
                    <br />
                    <strong>
                        {t`Our team will call you at the phone number provided in checkout and use your order number to verify your information.`}
                    </strong>
                    <br />
                    <br />
                    <strong>
                        {t`Alternatively you may try placing your order again later. We sincerely apologize for any inconvenience.`}
                    </strong>
                </p>
            </div>
        );
    }
}
